module.exports = __webpack_public_path__ + "static/img/Christmas_Menu_CN.e08cb02.png";